import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
export default function BrandCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = [
    {
      title: "CRAFTING THE FUTURE",
      subtitle: "Innovation Powers Our Vision",
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=800&fit=crop"
    },
    {
      title: "BUILT ON INTELLIGENCE",
      subtitle: "AI Defines Everything We Do",
      image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&h=800&fit=crop"
    },
    {
      title: "BEYOND TECHNOLOGY",
      subtitle: "We Engineer Intelligent Possibilities",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=800&fit=crop"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div style={styles.container}>
      <div style={styles.slideWrapper}>
        <div style={styles.leftSection}>
          <p style={styles.subtitle}>{slides[activeIndex].subtitle}</p>
          <h1 style={styles.title}>{slides[activeIndex].title}</h1>
          <div style={styles.buttonGroup}>
            <button style={styles.primaryButton} >
  <Link to="/contact" style={{ textDecoration: "none", color: "white"}}>
     Connect Now
  </Link>
</button>

           
          </div>
          <div style={styles.pagination}>
            <span style={styles.pageNumber}>0{activeIndex + 1}</span>
            <span style={styles.pageDivider}></span>
            <span style={styles.pageNumber}>03</span>
          </div>
        </div>
        <div style={styles.rightSection}>
          <img src={slides[activeIndex].image} alt={slides[activeIndex].title} style={styles.image} />
          {/* <div style={styles.enquireButton}>
            <span style={styles.enquireText}>Enquire Now</span>
            <span style={styles.arrow}>↑</span>
          </div> */}
        </div>
      </div>
      <div style={styles.indicators}>
        {slides.map((_, index) => (
          <button
            key={index}
            style={{
              ...styles.indicator,
              ...(index === activeIndex ? styles.activeIndicator : {})
            }}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
  },
  slideWrapper: {
    display: 'flex',
    height: '100vh',
    width: '100%',
  },
  leftSection: {
    flex: 1,
    backgroundColor: '#000',
    color: '#fff',
    padding: '80px 60px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  subtitle: {
    fontSize: '14px',
    letterSpacing: '3px',
    marginBottom: '20px',
    fontWeight: '500',
  },
  title: {
    fontSize: '72px',
    fontWeight: '700',
    lineHeight: '1.1',
    marginBottom: '50px',
    maxWidth: '600px',
  },
  buttonGroup: {
    display: 'flex',
    gap: '20px',
    marginBottom: '60px',
    flexWrap: 'wrap',
  },
  primaryButton: {
    backgroundColor: '#E91E63',
    color: '#fff',
    border: 'none',
    padding: '18px 35px',
    borderRadius: '50px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    transition: 'transform 0.2s',
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    color: '#fff',
    border: '2px solid #fff',
    padding: '18px 35px',
    borderRadius: '50px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    transition: 'all 0.2s',
  },
  icon: {
    fontSize: '18px',
  },
  pagination: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  pageNumber: {
    fontSize: '18px',
    fontWeight: '300',
  },
  pageDivider: {
    width: '80px',
    height: '2px',
    backgroundColor: '#fff',
  },
  rightSection: {
    flex: 1,
    position: 'relative',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  enquireButton: {
    position: 'absolute',
    bottom: '30px',
    right: '30px',
    backgroundColor: '#fff',
    color: '#000',
    padding: '15px 25px',
    borderRadius: '50px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
  },
  enquireText: {
    fontSize: '16px',
    fontWeight: '600',
  },
  arrow: {
    fontSize: '20px',
    fontWeight: '700',
  },
  indicators: {
    position: 'absolute',
    bottom: '30px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '10px',
    zIndex: 10,
  },
  indicator: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    border: '2px solid #fff',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  activeIndicator: {
    backgroundColor: '#fff',
  },
};